import { render } from "./ViolationSettingsCard.vue?vue&type=template&id=46eba427"
import script from "./ViolationSettingsCard.vue?vue&type=script&lang=js"
export * from "./ViolationSettingsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__